// Google Analytics 4 (gtag.js) — chargé UNIQUEMENT sur le domaine de production interko.io
// (jamais en preview/localhost) afin de ne pas polluer les statistiques. L'ID de mesure vient
// exclusivement de la variable d'environnement REACT_APP_GA4_MEASUREMENT_ID (pas de valeur en dur).
const MEASUREMENT_ID = process.env.REACT_APP_GA4_MEASUREMENT_ID;

function isProdHost() {
  try {
    const h = (window.location.hostname || "").toLowerCase();
    return h === "interko.io" || h === "www.interko.io" || h.endsWith(".interko.io");
  } catch {
    return false;
  }
}

export const analyticsEnabled =
  !!MEASUREMENT_ID && /^G-[A-Z0-9]+$/i.test(MEASUREMENT_ID) && isProdHost();

// ---- Consentement RGPD ----
const CONSENT_KEY = "interko_cookie_consent"; // "granted" | "denied"

export function hasConsentChoice() {
  try { return !!localStorage.getItem(CONSENT_KEY); } catch { return false; }
}
export function consentGranted() {
  try { return localStorage.getItem(CONSENT_KEY) === "granted"; } catch { return false; }
}
// Le bandeau s'affiche dès qu'un ID GA4 est configuré et qu'aucun choix n'a été fait.
// (GA4 ne se charge réellement que sur le domaine de prod ET après consentement.)
export function shouldShowConsentBanner() {
  return !!MEASUREMENT_ID && /^G-[A-Z0-9]+$/i.test(MEASUREMENT_ID) && !hasConsentChoice();
}

let initialized = false;

export function initAnalytics() {
  // GA4 ne se charge QUE : (1) sur le domaine de prod, (2) après consentement explicite.
  if (!analyticsEnabled || !consentGranted() || initialized) return false;
  window.dataLayer = window.dataLayer || [];
  // eslint-disable-next-line prefer-rest-params
  window.gtag = function gtag() { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  // send_page_view:false → on contrôle nous-mêmes les pages vues (SPA) pour éviter les doublons.
  window.gtag("config", MEASUREMENT_ID, { send_page_view: false });
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(MEASUREMENT_ID)}`;
  document.head.appendChild(s);
  initialized = true;
  return true;
}

export function grantConsent() {
  try { localStorage.setItem(CONSENT_KEY, "granted"); } catch { /* noop */ }
  if (initAnalytics()) pageView();
}

export function denyConsent() {
  try { localStorage.setItem(CONSENT_KEY, "denied"); } catch { /* noop */ }
}

// Page vue SPA (à chaque changement de route). Les visites uniques sont dérivées
// automatiquement par GA4 à partir du client_id / user.
export function pageView(pathWithSearch) {
  if (!analyticsEnabled || !window.gtag) return;
  window.gtag("event", "page_view", {
    page_title: document.title,
    page_location: window.location.href,
    page_path: pathWithSearch || (window.location.pathname + window.location.search),
  });
}

// Événement personnalisé (free_trial_click, sign_up, select_plan...). No-op tant que GA4
// n'est pas actif (preview/localhost) — sûr à appeler partout.
export function trackEvent(name, params = {}) {
  if (!analyticsEnabled || !window.gtag) return;
  window.gtag("event", name, params);
}
